import { apiClient } from '@lib/api/client';
import type { ExcelReportRequest, ZReportRequest, BranchOfficeSearchResponse } from '../types/report.types';

export const reportService = {
  /**
   * Search branch offices for report filtering
   */
  async searchBranchOffices(companyId: string): Promise<BranchOfficeSearchResponse> {
    const response = await apiClient.post<BranchOfficeSearchResponse>('/reports/branch-offices/search', {
      CompanyId: companyId,
      PageNumber: 1,
      PageSize: 100,
      IsActive: true,
    });
    return response.data;
  },

  /**
   * Generate Excel report for issued documents
   */
  async generateExcelReport(request: ExcelReportRequest): Promise<Blob> {
    const response = await apiClient.post<Blob>('/reports/excel', request, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  /**
   * Generate Z Report (PDF)
   */
  async generateZReport(request: ZReportRequest): Promise<Blob> {
    const response = await apiClient.post<Blob>('/reports/build', request, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  /**
   * Download the Excel report
   */
  downloadExcelReport(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },

  /**
   * Download the PDF report
   */
  downloadPdfReport(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
